import home from '@/views/home'
export default {
  path: 'home',
  name: 'home',
  meta: { title: '首页' },
  component: home,
}
